import React from "react";

function SvgIcMapPoi033(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M16.499 22.97a1.5 1.5 0 110 3.001 1.5 1.5 0 010-3.001zm-6 0a1.5 1.5 0 110 3.001 1.5 1.5 0 010-3.001zm12.4-15.997L25 6.97a1 1 0 01.117 1.993L25 8.97h-1.314l-4.584 11.934c-.002.004-.2.443-.203.447-.164.353-.475.58-1.161.612l-.18.004L9 21.97a1 1 0 01-.117-1.993L9 19.97h8.312l.77-2H9c-.41 0-.721-.187-.888-.53l-.05-.12-1.999-6c-.316-.926.278-1.308.825-1.347l.086-.003H21.16l.917-2.379-.008.012c.112-.31.275-.585.707-.625l.124-.005L25 6.97z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgIcMapPoi033;
